import { render, staticRenderFns } from "./ExpandableItemDocuments.vue?vue&type=template&id=3306091e&scoped=true"
import script from "./ExpandableItemDocuments.vue?vue&type=script&lang=js"
export * from "./ExpandableItemDocuments.vue?vue&type=script&lang=js"
import style0 from "./ExpandableItemDocuments.vue?vue&type=style&index=0&id=3306091e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3306091e",
  null
  
)

export default component.exports